<app-header></app-header>

<app-cookies-modal #modal [modalConfig]="modalConfig">
</app-cookies-modal>
  

<section id="equipo-int" class="bg-light reset-section-pad2">

  <div class="container" data-aos="fade-right" data-aos-duration="1500">

        <div class="row" >
           <div class="col-lg-12 mb-4">
                 <h1 class="fw-bold">POLITICA COOKIES DE RETAILCOMPANY 2021, S.L.</h1>
               
           </div>   
       </div>


        <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>1.  Entidad Responsable</h2>
                <p>Mediante este aviso, Retailcompany 2021, S.L. es una sociedad española con domicilio social en la calle Quintanavides Nº 13, Edificio 1 Planta 4 de Madrid (28050), con CIF B-67661090, inscrita en el Registro Mercantil de Madrid al tomo 42.610, folio 160, hoja M-753707, inscripción 1ª (en adelante, “RetailCo” o el “Editor” indistintamente), informa a los visitantes de la web o a los usuarios de la aplicación en su caso (en adelante los “Usuarios” o el “Usuario” y la “Web” o la “App” respectivamente) acerca de su política de cookies, para que los mismos tengan conocimiento de las cookies que serán utilizadas durante su navegación a través de la Web o de su uso de la App y puedan prestar su consentimiento a las mismas.</p>
           </div>   
       </div>


        <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>2.  ¿Qué son las Cookies?</h2>
                <p>Las cookies pueden definirse como cualquier tipo de dispositivo de almacenamiento y recuperación de datos que se utilice en el equipo terminal de un Usuario (ordenador/smartphone/tablet) que navega por internet con la finalidad de almacenar información y recuperar la información ya almacenada.</p>

                <p>Las cookies pueden ser instaladas, bien directamente por los sitios web que visita el Usuario o bien por terceros con los que se relaciona el sitio web, y permiten a éste conocer su actividad en el mismo sitio o en otros con los que se relaciona éste, por ejemplo: el lugar desde el que accede, el tiempo de conexión, el dispositivo desde el que accede (fijo o móvil), el sistema operativo y navegador utilizados, las páginas más visitadas, el número de clics realizados y de datos respecto al comportamiento del Usuario en Internet.</p>

                <p>Para más información sobre como las páginas webs y apps usan cookies, pinche en <a rel="noopener" href="https://www.allaboutcookies.org/es/" target="_blank">https://www.allaboutcookies.org/es</a></p>
           </div>   
       </div>

        <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>3.  Protección de datos personales</h2>
                <p>En determinadas circunstancias, el empleo de dispositivos de almacenamiento y recuperación de datos en equipos terminales de los destinatarios, como las cookies, puede llegar a implicar un tratamiento de datos de carácter personal. Dicho tratamiento de datos se encontrará legitimado a condición de que los Usuarios de la Web o la App hayan dado su consentimiento después de que se les haya facilitado información clara y completa sobre su utilización, en particular, sobre los fines del tratamiento de los datos, en materia de protección de datos de carácter personal.</p>

                <p>A estos efectos debe tenerse en cuenta que política de cookies (en adelante, “Política de Cookies”), se complementa con la política de privacidad de esta Web o de la App.</p>
           </div>   
       </div>
    

         <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>4.  Tipos de Cookies utilizadas</h2>
                <p>Esta Web utiliza los siguientes tipos de cookies:</p>
           </div>   
       </div>

         <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>4.1. Cookies técnicas y estrictamente necesarias.</h2>
                <p>Son aquellas cookies insertadas por el Editor que resultan necesarias para el buen funcionamiento de la página Web o para suministrar un servicio solicitado por el Usuario respectivamente. En este sentido se consideran como necesarias aquellas cookies de personalización o preferencias que permiten recordar información para que el Usuario acceda al servicio con determinadas características que puedan diferenciar su experiencia de la de otros Usuarios, como por ejemplo serían el idioma o el número de resultados a mostrar en una búsqueda.</p>
                <p>Entre las cookies técnicas se incluyen por ejemplo las cookies de personalización de la interfaz de Usuario, las que el Editor utiliza para controlar el tráfico y la comunicación de datos, identificar la sesión, las cookies para compartir contenidos en redes sociales, etc.</p>
                <p>Tal y como establece el art. 22.2 de la LSSI no es necesario el consentimiento para su uso.</p>
                <p>En la siguiente tabla encontrará información más detallada sobre este tipo de cookies:</p>
                 <div class="table-responsive"> 
                    
                       <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Finalidad</th>
                               <th scope="col">Duración / Expiración</th>
                               
                              </tr>
                            </thead>
                            <tbody>
                         <tr>
                              <td>tmCookie</td>
                              <td>Token de identificación de admisión de cookies publicitarias</td>
                             <td>12 meses</td>
                            
                          </tr>
                          <tr>
                              <td>isCookieSubmitted</td>
                              <td>Token de identificación de admisión de cookies</td>
                              <td>12 meses</td>
                             
                          </tr>
                       
            
                        </tbody>
                      </table>
                 </div>
 
           </div>   
       </div>


        <div class="row" >
           <div class="col-lg-12 mb-5">
                <h2>4.2. Cookies Analíticas o de Rendimiento</h2>
                <p>Estas cookies pueden ser propias o de terceros y permiten al Editor el seguimiento y análisis del comportamiento de los Usuarios cuando navegan por la Web o utilizan sus servicios. Gracias a ellas el Editor puede saber qué páginas son las más o las menos visitadas, cómo los visitantes navegan por el sitio y analizar la navegación permitiéndole introducir mejoras en función del análisis de esta información de uso. La información que se maneja no permite identificar unívocamente al Usuario.</p>
                <p>Entre las cookies analíticas que se utilizan en esta Web están las cookies de GOOGLE ANALYTICS.  GOOGLE ANALYTICS es un servicio de análisis web facilitado por Google Ireland. Concretamente el uso de GOOGLE ANALYTICS permite al Editor monitorizar cómo los visitantes usan la Web, recopilar informes y ayudar a mejorar la Web. </p>
                <p>Si consiente la instalación de cookies de analítica web o de rendimiento en su dispositivo, tenga en cuenta que se instalarán cookies de GOOGLE ANALYTICS. La instalación de estas cookies podrá implicar la realización por parte de Google Ireland de transferencias internacionales de datos a Estados Unidos, lo que podría suponer, en casos muy aislados y específicos, el acceso a los datos por parte de las autoridades de este país en el desarrollo de labores de investigación y de seguridad nacional. No obstante, dentro de nuestros altos estándares de cumplimiento en materia de privacidad, le informamos de que hemos  suscrito con Google las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea el 4 de junio de 2021 como mecanismo de garantía reconocido por el RGPD con el objetivo de preservar la seguridad de los datos que puedan ser objeto de una transferencia internacional, así como la adopción de medidas adicionales tendentes a proteger la confidencialidad y la integridad de los mismos.</p>
                <p>En la siguiente tabla encontrará información más detallada sobre este tipo de cookies:</p>
                       <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">Titular (huésped)</th>
                                <th scope="col">Nombre</th>
                               <th scope="col">Finalidad</th>
                                <th scope="col">Duración/Periodo de expiración o vida útil</th>
                               
                              </tr>
                            </thead>
                            <tbody>
                         <tr>
                              <td>Google</td>
                              <td>_ga</td>
                              <td>habilita la función de control de visitas únicas.</td>
                             <td>24 meses</td>
                            
                          </tr>
                          <tr>
                               <td>Google</td>
                               <td>_gat</td>
                              <td>Se utiliza para limitar la velocidad de petición - la limitación de la recogida de datos en los sitios de alto tráfico.</td>
                              <td>19 minutos</td>
                             
                          </tr>

                           <tr>
                               <td>Google</td>
                               <td>_gid</td>
                              <td>Se utiliza para distinguir a los Usuarios.</td>
                              <td>24 horas</td>
                             
                          </tr>
                       
            
                        </tbody>
                      </table>
            
              </div>
      </div>


       <div class="row" >
            <div class="col-lg-12 mb-5">
                <h2>5.  ¿Cuál es la base legitimadora para el uso de cookies?</h2>
                <p>Salvo para los supuestos de cookies técnicas y estrictamente necesarias que no precisan de un consentimiento informado del Usuario para su uso, el Editor únicamente insertará cookies en el equipo del Usuario previo consentimiento informado del mismo. En este sentido el consentimiento puede otorgarse o bien clicando en el botón de “Aceptar todas las cookies” o bien configurando aquellas para las que el Usuario opte libremente por prestar su consentimiento a través del panel de configuración de cookies que el Editor ha puesto a su disposición la primera vez que accede a la Web o a la App.</p>
           </div>   
       </div>



         <div class="row" >
               <div class="col-lg-12 mb-5">
                    <h2>6.  ¿Puede revocar su consentimiento?</h2>
                  
                  <p>Una vez instaladas las cookies el Usuario podrá en cualquier momento optar por revocar su consentimiento y eliminar las mismas. Para ello podrá o bien:</p>
             
                  <ul>
                      <li>Utilizar las opciones de configuración de contenidos y privacidad disponibles en el navegador que esté utilizando durante la navegación web. Así, en función del tipo de navegador que el Usuario utilice, el procedimiento para la revocación y eliminación de las cookies podría ser, a título ilustrativo, alguno de los siguientes:
                      <ul>
                          <li><a rel="noopener" href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectlocale=es&redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we" target="_blank">Firefox</a></li>
                          <li><a rel="noopener" href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank">Microsoft Edge</a></li>
                          <li><a rel="noopener" href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank">Safari</a></li>
                           <li><a rel="noopener" href="http://help.opera.com/Windows/8.54/es-ES/index.html" target="_blank">Opera</a></li>
                          <li><a rel="noopener" href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank">Chrome</a></li>
                      </ul>
                      </li>
                      </ul>
                  
                  <ul>
                      <li>Reconfigurar las cookies aceptadas a través del panel de configuración de cookies que el Editor pone a su disposición en todo momento y al que puede acceder a través del siguiente botón:</li>
                      
                    </ul>
                    <button type="button" id="button" class="btn-rco-cookies"  (click)="openModal()">Configurar cookies</button>

        

               </div>   
           </div>


        <div class="row" >
            <div class="col-lg-12 mb-5">
                <h2>7.  Actualización de la Política de Cookies y contacto</h2>
                <p>Esta Política de Cookies puede ir variando en función de las cookies que se utilicen. En caso de que se incluyan nuevos tipos de cookies para las que se requiera un consentimiento informado el Editor informará debidamente al Usuario y recabará el debido consentimiento.</p>
<p>Sin perjuicio de lo establecido en el párrafo anterior, el Editor le recomienda revisar esta política cada vez que acceda a nuestro sitio Web con el objetivo de estar adecuadamente informado sobre cómo y para qué usamos las cookies y pueda tener conocimiento de cualquier cambio en el tipo de datos que se recogen. </p>
<p>Si el Usuario desea realizar alguna pregunta sobre la Política de Cookies del Portal se puede poner en contacto con el Editor a través de la siguiente dirección: <a href="mailto:info1@retailco.es">info1@retailco.es</a> indicando en el asunto “Política de Cookies”.</p>
           </div>   
       </div>


         






   </div><!-- fin container-->

</section>


<app-footer-main></app-footer-main>